import { useEffect, useRef } from "react";
import { motion, useInView, useMotionValue, useSpring } from "framer-motion";

const STATS = [
  { value: 10, suffix: "+", label: "Years of Real Estate Excellence" },
  { value: 1000, suffix: "+", label: "Satisfied Families" },
  { value: 500, prefix: "₹", suffix: " Cr+", label: "Worth Properties Sold" },
  { value: 4.9, suffix: " / 5", label: "Star Rated on Google Reviews", decimal: true },
];

const StatItem = ({ stat, index }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const mv = useMotionValue(0);
  const spring = useSpring(mv, { duration: 5000, bounce: 0 });

  useEffect(() => {
    if (inView) mv.set(stat.value);
  }, [inView, stat.value, mv]);

  useEffect(() => {
    const unsub = spring.on("change", (v) => {
      if (ref.current) {
        const num = stat.decimal ? v.toFixed(1) : Math.round(v).toLocaleString("en-IN");
        ref.current.textContent = `${stat.prefix || ""}${num}${stat.suffix || ""}`;
      }
    });
    return unsub;
  }, [spring, stat]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 30, rotateX: 18, transformPerspective: 800 }}
      whileInView={{ opacity: 1, y: 0, rotateX: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay: index * 0.12, ease: [0.22, 1, 0.36, 1] }}
      className="text-center"
      data-testid={`trust-stat-${index}`}
    >
      <p ref={ref} className="whitespace-nowrap font-sans text-4xl font-bold tracking-tight text-navy-900 sm:text-5xl">
        {stat.prefix || ""}0{stat.suffix || ""}
      </p>
      <span className="mx-auto mt-4 block h-0.5 w-8 bg-gold-500" aria-hidden="true" />
      <p className="mx-auto mt-3 max-w-[180px] text-sm font-normal leading-snug text-gray-500">
        {stat.label}
      </p>
    </motion.div>
  );
};

export const StatsCounter = () => (
  <section className="bg-white py-20 sm:py-28" data-testid="trust-stats-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid grid-cols-2 gap-x-6 gap-y-14 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <StatItem key={i} stat={s} index={i} />
        ))}
      </div>
    </div>
  </section>
);
